import script from "./easter.vue?vue&type=script&lang=ts&setup=true"
export * from "./easter.vue?vue&type=script&lang=ts&setup=true"

import "./easter.vue?vue&type=style&index=0&id=50c63a55&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50c63a55"]])

export default __exports__